import stepAlertCompanyAddress from '../components/alert-company-address'
import stepAlertCompanyStaff from '../components/alert-company-staff'

export default {
  stepAlertCompanyAddress,
  stepAlertCompanyStaff
}



// WEBPACK FOOTER //
// ./src/app/professional/company/prices/resources/components.js